import React, { useEffect } from 'react';
import {
  CgCertificateStatus,
  IBilledOrderData,
  ICgCertificateResponse
} from '../../../../../../../store/ducks/long-steel-orders/types';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../../../../store/ducks/tagging/actions';
import { Icon } from '@gerdau/hefesto';
import {
  IconWrapper,
  Link,
  LoadingContainer
} from '../QualityCertificationColumn/styles';
import { SpinnerIcon } from '../../../../../../../components/Commons/SpinnerIcon/styles';
import {
  cgQcDownload,
  cgQcRequest
} from '../../../../../../../store/ducks/long-steel-orders/actions';
import { addToast } from '../../../../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../../../../store/ducks/toast/types';
import {
  RcaKind,
  sendRcaLogs
} from '../../../../../../../store/ducks/observability/actions';

interface CGQualityCertificateColumnProps {
  item: IBilledOrderData;
}

const CGQualityCertificateColumn: React.FC<CGQualityCertificateColumnProps> = ({
  item
}) => {
  const dispatch = useDispatch();

  const downloadFromUseEffect = () => {
    if (
      item.qcState?.cgQcCertificateResponse &&
      isValidFile(item.qcState.cgQcCertificateResponse)
    ) {
      dispatch(cgQcDownload(item));
      dispatch(sendRcaLogs(RcaKind.DownloadItem, 'CQC', item.id));
      downloadFile(item.qcState.cgQcCertificateResponse);
    }
  };

  const isNormal = !item.qcState?.loading && !item.qcState?.error;
  const isDownloadable = item.qcState?.canDownloadQC;
  const isLoading = item.qcState?.loading;
  const hasError = item.qcState?.error;
  const statusItem = item.billingHistory.statusQC;

  useEffect(() => {
    if (
      !item.qcState.alreadyDownloaded &&
      item.qcState.cgQcCertificateResponse
    ) {
      downloadFromUseEffect();
    }
  }, [item.qcState]);

  const downloadCGCertificate = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    if (item.billingHistory.statusQC === CgCertificateStatus.Ready) {
      dispatch(
        sendTagging({
          screenName: 'LG:PainelGestao:Selecao',
          event: 'click',
          itemName: 'button:baixarcertificadocg',
          itemDescription: 'pedidoscg_baixarcertificadodequalidade'
        })
      );
      if (
        item.qcState.cgQcCertificateResponse &&
        isValidFile(item.qcState.cgQcCertificateResponse)
      ) {
        downloadFile(item.qcState.cgQcCertificateResponse);
      } else {
        dispatch(cgQcRequest(item));
      }
    }
  };

  const downloadFile = (
    qcFileResponse: ICgCertificateResponse['content'][0]
  ) => {
    const link = document.createElement('a');
    const dataurl = 'data:text/plain;base64,' + qcFileResponse.buffer;
    link.setAttribute('href', dataurl);
    link.style.display = 'none';
    link.setAttribute('download', qcFileResponse.filename ?? '');
    link.click();
    dispatch(
      addToast({
        message: 'Certificado baixado com sucesso!',
        type: EToastTypes.SUCCESS,
        durationInMS: 5000
      })
    );
  };

  const qcSolicitation = () => {
    const cqStatus = item.billingHistory.statusQC;
    if (cqStatus === CgCertificateStatus.Available) {
      dispatch(
        sendTagging({
          screenName: 'LG:PainelGestao:Selecao',
          event: 'click',
          itemName: 'button:solicitarcertificadocg',
          itemDescription: 'pedidoscg_solicitarcertificadodequalidade'
        })
      );
      dispatch(cgQcRequest(item));
    }
  };

  const renderCGButton = (item: IBilledOrderData) => {
    const status = statusItem ?? CgCertificateStatus.Error;
    const plantsNotAllowed = [
      '60',
      '62',
      '63',
      '64',
      '69',
      '70',
      '71',
      '73',
      '74',
      '75'
    ];
    if ('BRCG' == item.billingHistory.salesOrganization.toUpperCase()) {
      for (const na of plantsNotAllowed) {
        if (item.billingHistory.division == na) {
          return <Link $disabled>Indisponível</Link>;
        }
      }
    }
    switch (status) {
      case CgCertificateStatus.Available:
        return (
          <Link onClick={qcSolicitation} $extraPadding="0.5">
            Solicitar Certificado
          </Link>
        );
      case CgCertificateStatus.Processing:
        return <Link $disabled>Em processamento</Link>;
      case CgCertificateStatus.Ready:
        return (
          <IconWrapper onClick={downloadCGCertificate}>
            <Icon option={'ImagePlaceholder'} variant="primary" size="sm" />
            <Link onClick={downloadCGCertificate}>Baixar Certificado</Link>
          </IconWrapper>
        );
      case CgCertificateStatus.Error:
      case CgCertificateStatus.ErrorMail:
      case CgCertificateStatus.NotFound:
      default:
        return <Link $disabled>Indisponível</Link>;
    }
  };

  function isValidFile(
    cgQCResponse?: ICgCertificateResponse['content'][0]
  ): boolean {
    if (
      cgQCResponse?.buffer &&
      cgQCResponse?.buffer != 'Certificado não encontrado'
    ) {
      return true;
    }
    return false;
  }

  return (
    <>
      {isDownloadable && isNormal && renderCGButton(item)}
      {isLoading && (
        <LoadingContainer>
          <SpinnerIcon style={{ margin: '0.125rem' }} />
          {statusItem === CgCertificateStatus.Available
            ? 'Solicitando Certificado'
            : 'Baixando Certificado'}
        </LoadingContainer>
      )}

      {hasError && !isLoading && <Link $disabled>Indisponível</Link>}

      {!isDownloadable && <Link $disabled>Indisponível</Link>}
    </>
  );
};

export default CGQualityCertificateColumn;
